import { IRequestPharmacy } from '../Request/types';

/** One-line summary for pharmacy ward request list rows, e.g. "Paracetamol (×3), …". */
export function formatPharmacyItemsSummary(items: IRequestPharmacy[] | undefined | null): string {
    if (!items?.length) {
        return '';
    }

    return items
        .map((item) => {
            const name = item.pharmacyItem?.name ?? '';
            const qty = item.amountRequested ?? 0;
            return qty > 0 ? `${name} (×${qty})` : name;
        })
        .filter(Boolean)
        .join(', ');
}
